import React from 'react';

const Tuition = () => {
    return (
        <div>
            
        </div>
    )
}

export default Tuition;
